'use client';

import { useEffect } from 'react';
import { captureTrafficAttribution } from '@/lib/tracking/traffic-attribution';

/**
 * TrafficTracker — Invisible component that captures traffic attribution.
 *
 * Drop this into any landing/marketing page to automatically:
 * 1. Capture document.referrer + UTM params
 * 2. Identify AI sources (ChatGPT, Perplexity, Claude, etc.)
 * 3. Store first-touch + last-touch attribution in localStorage
 * 4. Fire Vercel Analytics custom events for dashboard reporting
 *
 * Renders nothing. Runs once on mount.
 */
export default function TrafficTracker() {
  useEffect(() => {
    captureTrafficAttribution();
  }, []);

  return null;
}
